<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <relatorio-retornou-origem-list-concluidos
      :headers="headers"
      :tela="permission"
      ref="concluidos"
      @loading="loading = true"
      @loaded="loading = false"
    />
  </div>
</template>

<script>
import RelatorioRetornouOrigemListConcluidos from './RelatorioRetornouOrigemListConcluidos.vue'

import { Sequences } from '@/utils/permissions'
export default {
  name: 'RelatorioRetornouOrigemList',
  props: {
    headers: {
      type: Array,
    },
  },
  components: {
    RelatorioRetornouOrigemListConcluidos,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    permission() {
      return Sequences.RetornouOrigem.toString()
    },
  },
  methods: {
    async handleGetAgendamentos() {
      await this.$refs.concluidos.handleGetAgendamentos()
    },
  },
}
</script>
